/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('flush', require('./components/FlushMessage.vue').default)
Vue.component('channel-list', require('./components/ChannelList.vue').default)
Vue.component('player', require('./components/Player.vue').default)
Vue.component('upload-form', require('./components/UploadFormComponent.vue').default);
Vue.component('datetime', require('./components/DateTimeComponent.vue').default);
Vue.component('tagselect', require('./components/TagAutoInputComponent.vue').default);
Vue.component('block-form-component', require('./components/BlockFormComponent.vue').default);
Vue.component('block-edit-component', require('./components/BlockEditComponent.vue').default);
Vue.component('block-component', require('./components/BlockComponent.vue').default);
Vue.component('screenshots', require('./components/ScreenshotModalComponent.vue').default);

//Vue.component('anchorscroll', require('./components/AnchorScroll.vue').default);
Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import _ from 'lodash'
Vue.prototype.__ = str => _.get(window.i18n, str);

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'https://dummyimage.com/130x120/ccc/999.png&text=Not+Found',
    loading: 'https://dummyimage.com/130x120/dcdcdc/999.png&text=Now loading',
    attempt: 1
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

const app = new Vue({
    el: '#app',
    data() {
        return {
            is_uploding: false,
            is_submit: false
        }
    },
    methods: {
        uploadingStatus(status) {
            console.log('uploading', status);
            this.is_uploding = status;
        },
        doCopyDownloadUrl(url) {
            this.$copyText(url).then(function (e) {
                alert('Copied')
                //console.log(e)
            }, function (e) {
                alert('Can not copy')
                //console.log(e)
            })
        },
        doCopyText(textInput) {
            const text = $(`#${textInput}`).val();
            navigator.clipboard.writeText(text).then(() => {
                alert('Copied');
            }).catch(err => {
                alert('Can not copy');
            });
        },
        checkToggle(agreeCheckboxId, downloadButtonId) {
            const checkbox = `#${agreeCheckboxId}`;
            const button = `#${downloadButtonId}`;
            $(checkbox).on('change', function () {
                if ($(this).is(':checked')) {
                    $(button).prop('disabled', false);
                } else {
                    $(button).prop('disabled', true);
                }
            });
        },
        generateRandomPassword() {
            const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            let password = "";
            for (let i = 0; i < 8; i++) {
                password += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return password;
        },
        generatePassword(passwordField) {
            const passwordInput = $(`#${passwordField}`);
            const password = this.generateRandomPassword();
            passwordInput.val(password);
        },
        handlePasswordOptionChange(passwordSelect, passwordField, passwordBtn) {
            const passwordOption = $(`#${passwordSelect}`).val();
            const passwordInput = $(`#${passwordField}`);
            const generatePasswordBtn = $(`#${passwordBtn}`);

            if (passwordOption === 'あり') {
                passwordInput.val(this.generateRandomPassword());
                generatePasswordBtn.prop('disabled', false);
            } else {
                passwordInput.val('');
                generatePasswordBtn.prop('disabled', true);
            }
        },
        generateDownloadSetting(video_id, text, filetype, user_id, image_id = null) {
            const url = `/dashboard/videos/${video_id}/create_download_setting`;
            const deadline = $('input[name="deadline"]').val();
            $("#shareDownloadModalLabel").text(text);

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    video_id: video_id,
                    user_id: user_id,
                    image_id: image_id,
                    limit: 10,
                    password: '',
                    deadline: deadline,
                    filetype: filetype
                })
            })
                .then(response => response.json())
                .then(data => {
                    let download_url = data.encrypted_url;
                    if(image_id) {
                        download_url = download_url + '?image_id=' + image_id;
                    }
                    $("#downloadSettingUpdate").val(data.id);
                    $("#downloadURL").val(download_url);
                })
                .catch(error => console.error("Error:", error));
        },
        updateDownloadSetting(video_id) {
            const url = `/dashboard/videos/${video_id}/update_download_setting`;
            const deadline = $('input[name="deadline"]').val();
            const limit = $('input[name="limit"]').val();
            const password = $('input#passwordField').val();
            const id = $("#downloadSettingUpdate").val();


            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    id: id,
                    video_id: video_id,
                    limit: limit,
                    password: password,
                    deadline: deadline
                })
            })
                .then(response => response.json())
                .then(data => {
                    const messageElement = document.getElementById('updateMessage');

                    // メッセージを更新
                    messageElement.textContent = data.message;

                    // メッセージを表示
                    messageElement.style.display = 'block';

                    // 10秒後に非表示にする
                    setTimeout(() => {
                        messageElement.style.display = 'none';
                    }, 10000);
                })
                .catch(error => {
                    const messageElement = document.getElementById('updateMessage');
                    messageElement.textContent = 'Failed to change download settings information.';
                    messageElement.style.display = 'block';
                    setTimeout(() => {
                        messageElement.style.display = 'none';
                    }, 5000);
                    console.error("Error:", error);
                });
        },
        DOMContentLoaded() {
            const selectAllCheckbox = document.getElementById('selectAll');
            const childCheckboxes = document.querySelectorAll('.child-checkbox');

            // 親チェックボックスのイベントリスナー
            selectAllCheckbox.addEventListener('change', (event) => {
                const isChecked = event.target.checked;
                childCheckboxes.forEach(checkbox => {
                    checkbox.checked = isChecked;
                });
            });

            // 子チェックボックス全体の状態を確認して親チェックボックスを更新
            childCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    const allChecked = Array.from(childCheckboxes).every(cb => cb.checked);
                    const anyChecked = Array.from(childCheckboxes).some(cb => cb.checked);

                    // 親チェックボックスの状態を設定
                    selectAllCheckbox.checked = allChecked;
                    selectAllCheckbox.indeterminate = !allChecked && anyChecked;
                });
            });
        },
        disableButtonDuringProcess(event) {
            const button = event.target;

            button.disabled = true;

            const form = button.form;
            if (form) {
                form.submit();
            }
        },
        setDownloadUrl(url) {
            $("#downloadURL").val(url);
        },
    },
});
